import { Spin } from 'antd';
import React, { useState } from 'react';
import JuchuNyuryokuMain from '../../appForms/juchuNyuryoku/JuchuNyuryokuMain';
import Header from '../../common/compornents/layout/header/Header';

const JuchuNyuryokuComponent: React.FC = () => {
  // 表示切り替えフラグ
  const [displayFlg, updateDisplayFlg] = useState<boolean>(true);
  // インジケーター表示フラグ
  const [loading, changeLoading] = useState<boolean>(false);

  //表示切替
  const ChangeDisplay = () => {
    if (displayFlg === true) {
      updateDisplayFlg(false);
    } else {
      updateDisplayFlg(true);
    }
  };

  // JSX
  return (
    <div style={{ backgroundColor: '#e6f7ff', minHeight: '100vh' }}>
      <Spin spinning={loading}>
        <Header
          screenName={'注文入力'}
          showLogout={true}
          changeDisplay={true}
          changeDisplayFunction={ChangeDisplay}
        />
        <JuchuNyuryokuMain
          displayFlg={displayFlg}
          loading={loading}
          changeLoading={changeLoading}
        />
      </Spin>
    </div>
  );
};
export default JuchuNyuryokuComponent;
